import anime from "animejs";

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default {
  name: "trim-text",

  /*ui: {
    buttonWrapper: "[js-trim-text-btn-wrapper]",
    button: "[js-trim-text-btn]"
  },

  events: [
    {
      target: "button",
      on: "click",
      handle(e) {
        this.toggleText(e);
      }
    }
  ],*/

  componentDidMount() {
    this.ui.buttonWrapper = this.el.querySelector("[js-trim-text-btn-wrapper]");
    this.ui.button = this.el.querySelector("[js-trim-text-btn]");
    if (!this.ui.buttonWrapper || !this.ui.button) return;
    this.ui.button.addEventListener("click", this.toggleText);
    this.ui.buttonWrapper.classList.add("hidden");
    this.btnWording = this.ui.button.querySelector("span");
    this.trimmedText = this.el.querySelector(".trimmed-text");
    this.initialHeight = this.props.maxHeight;

    this.check();
    window.addEventListener("resize", this.check);
  },

  check() {
    this.trimmedText.style.height = "auto";
    this.destHeight = this.trimmedText.offsetHeight;

    if (this.trimmedText.offsetHeight > this.props.maxHeight) {
      this.ui.buttonWrapper.classList.remove("hidden");
    } else {
      this.ui.buttonWrapper.classList.add("hidden");
    }

    this.trimmedText.style.height = this.initialHeight + "px";
  },

  toggleText(e) {
    e.stopPropagation();
    const self = this;
    this.trimmedText.classList.toggle("trimmed-text--opened");
    if (this.trimmedText.classList.contains("trimmed-text--opened")) {
      anime({
        targets: self.trimmedText,
        height: self.destHeight,
        duration: 300,
        easing: "easeInOutQuad"
      });
      this.btnWording.innerText = "fermer";
      this.ui.button.classList.add("reversed");
    } else {
      anime({
        targets: self.trimmedText,
        height: self.initialHeight,
        duration: 300,
        easing: "easeInOutQuad"
      });

      this.btnWording.innerText = "voir plus";
      this.ui.button.classList.remove("reversed");

      //anime.set(el, { height: initialHeight });
    }
  }
};
